import {Injectable} from '@angular/core';

@Injectable()
export class WindowRefService {
  constructor() {}

  getNativeWindow() {
    return window;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/services/windowRef.service.ts